import React from "react";
import CustomTable from "../Utils/Tables/CustomTable";
import FilterResults from "react-filter-search";
import TableBody from "@material-ui/core/TableBody";
import {getComparator, stableSort} from "../Utils/Tables/sortingFunctions";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from "../../actions/snackbarActions";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import DeleteDialog from "../Utils/Dialogs/DeleteDialog";
import {useLabTypeList} from "./CustomHooks/useLabTypeList";
import { Container, ErrorMessage, RightAlignedContainer } from "../Utils/styledComponents";
import { ReusableRouteTabs } from "../Utils/Dialogs/ReusableTabs";
import { history } from "../../Helpers/history";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faVials} from "@fortawesome/free-solid-svg-icons/faVials";
import CustomDialog from "../Utils/Dialogs/CustomDialog";
import Form from 'react-bootstrap/Form'
import Label from "../Utils/FormInputs/Label";
import TextField from "../Utils/FormInputs/TextField";


const headData = [{id: 'sl', numeric: false, disablePadding: false, label: 'SL'},
    {id: 'labType', numeric: false, disablePadding: true, label: 'Lab Type'},
    {id: 'actions', numeric: false, disablePadding: true, label: 'Action'},
];

export const LabTypeList = ({actions, snackbars}) => {
    const {searchValue, order, orderBy, page, rowsPerPage, handleSearch, handleRequestSort,
        handleChangePage, handleChangeRowsPerPage, closeSnackbar,
         typeList:labTypes, openDelete, hospital_test_type, submitted,isPending, isLoading,
        handleChange,  handleSubmit, handleOpenDelete,test_type_id,
        handleCloseDelete, handleDelete, isSuccess, isError,
        openDialog, handleCloseDialog, handleOpenDialog}= useLabTypeList(actions)
    const {openBar, type, message} = snackbars;
    const components = [{label: 'Lab Tests', path: '/labsettings'},
    {label: 'Lab Types', path: '/labtype'},
    {label: 'Sample Types', path: '/addsample'},]
    return (
        <div>
            <PageTitle title="Laboratory Settings"/>
            <SubHeader title="Laboratory" subTitle="Laboratory settings">
                <FontAwesomeIcon icon={faVials}/>
            </SubHeader>
            <CustomDialog open={openDialog} handleClose={handleCloseDialog} title={`${test_type_id ? 'Edit':'Add'} Lab Type`}>
                <form autoComplete="off" onSubmit={handleSubmit}>
                    <Form.Group>
                        <Label name='Lab Type' htmlFor='lab_type' type/>
                        <TextField value={hospital_test_type} onChange={handleChange} id='lab_type'/>
                        {submitted && !hospital_test_type ? <ErrorMessage>This is a required field</ErrorMessage>:null}
                    </Form.Group>
                    <button type="submit" disabled={isPending} className="btn btn-sm sms-info-btn px-3">{isPending ? 'Saving...' :'Save'}</button>
                </form>
            </CustomDialog>
            <Container>
                <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <DeleteDialog message="Delete " openDialog={openDelete} handleClose={handleCloseDelete}
                                    text="lab type" title='Delete Lab Type'>
                        <button className='btn sms-btn-dismiss btn-sm' onClick={handleDelete}>Delete</button>
                        <button className="btn sms-grey-btn btn-sm" onClick={handleCloseDelete}>No</button>    
                </DeleteDialog>
                <RightAlignedContainer>
                    <button onClick={()=>handleOpenDialog('')} className="btn btn-sm sms-info-btn mb-1">Add Lab Type</button>
                </RightAlignedContainer>
                <CustomTable  title="Lab Types" handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            headData={headData} handler={handleSearch} page={page} rowsPerPage={rowsPerPage}
                            handleRequestSort={handleRequestSort} data={labTypes} colSpan={headData.length} order={order}
                            orderBy={orderBy} id="searchValue" filter>
                        <FilterResults value={searchValue} data={labTypes}
                            renderResults={results => (
                            <TableBody>
                                {isLoading ? <TableRow>
                                    <TableCell colSpan={headData.length} align="center"><img src="/images/smsloader.gif"
                                                                            alt="loader"/></TableCell>
                                </TableRow>:null}
                                {isSuccess ? labTypes.length > 0 ? stableSort(results, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item, index) => {
                                        const count = (page * rowsPerPage) + index + 1;
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={item.hospital_type_type_id}
                                                className='mui-table-row'
                                                id="unit"
                                            >
                                                <TableCell>{count}</TableCell>
                                                <TableCell >{item.hospital_test_type}</TableCell>
                                                <TableCell>
                                                    <button onClick={()=>handleOpenDialog(item.hospital_test_type_id)} className="btn btn-sm sms-info-btn mr-1">Edit</button>
                                                    <button onClick={()=>handleOpenDelete(item.hospital_test_type_id)} className="btn btn-sm sms-btn-dismiss">Delete</button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }):<TableRow>
                                    <TableCell colSpan={headData.length} align="center">No records found</TableCell>
                                </TableRow>:null}
                                {isError ? <TableRow>
                                    <TableCell colSpan={headData.length} align="center">The server did not return a valid response</TableCell>
                                </TableRow> : null}
                            </TableBody>
                        )}/>
                </CustomTable>
            </Container>
        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(LabTypeList);
